import React from 'react'
import { graphql } from "gatsby";
import { GatsbyImage as Image, getImage } from "gatsby-plugin-image";
import { renderContent } from "../../utilities/renderContent";
import { linkFormat } from '../../utilities/linkFormat'

export default function ListItemLink({ data }) {
  const {     
    link,
    link2,
    link3,
    caption,
    caption2,
    caption3,
    header,
    image2,
    image3,
    image 
  } = data

  return (
    <section className="hds-container hds-text-color relative z-10 py-8">
      <div className="text-center py-8">
        <h3 className="font-heading uppercase font-bold leading-tight text-3xl mb-4">
          {header}
        </h3>
      </div>
      <div className="w-full md:flex text-left hds-transition flex-col">
        <div className="w-full flex max-w-screen-xl my-0 mx-auto px-6 flex-col md:flex-row">
          <div className="flex-1 md:pr-6 mb-24 md:mb-0">
            <div className="px-6">
              <a href={linkFormat(link)}>
                <div className="hds-text-color text-center" dangerouslySetInnerHTML={renderContent(caption)} />
                <div className="object-cover object-center text-center">
                  <Image
                    image={getImage(image)}
                    alt={image.alt}
                  />
                </div>
              </a>
            </div>
          </div>
          <div className="flex-1 md:px-6 mb-24 md:mb-0">
            <div className="px-6">
              <a href={linkFormat(link2)}>
                <div className="hds-text-color text-center" dangerouslySetInnerHTML={renderContent(caption2)} />
                <div className="object-cover object-center text-center">
                  <Image
                    image={getImage(image2)}
                    alt={image2.alt}
                  />
                </div>
              </a>
            </div> 
          </div>
          <div className="flex-1 md:pl-6 mb-24 md:mb-0">
            <div className="px-6">
              <a href={linkFormat(link3)}>
                <div className="hds-text-color text-center" dangerouslySetInnerHTML={renderContent(caption3)} />
                <div className="object-cover object-center text-center">
                  <Image
                    image={getImage(image3)}
                    alt={image3.alt}
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export const LivHowItWorksQuery = graphql`
  fragment ListItemLinkComponent on DatoCmsListItemLink {
    internal {
      type
    }
    id
    header
    caption
    caption2
    caption3
    link
    link2
    link3
    image2 {
      alt
      gatsbyImageData
    }
    image3 {
      alt
      gatsbyImageData
    }
    image {
      alt
      gatsbyImageData
    }
  }
`